import {FooterType} from "../app/FooterType";
import {PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {pageId} from "../../services/ui/AppPageManager";
import {accountWServiceActions} from "../../services/ws/account/accountWServiceActions";
import {AccountActions} from "./AccountActions";

const footerType = (state = FooterType.LARGE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.LARGE;
    }
};

const loaded = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case accountWServiceActions.GET_USER_PROFILE_SUCCEEDED_ACTION.type:
            return true;
        default:
            return state;
    }
};

const webAuthnAvailable = (state : boolean = false, action : PledgerAction) => {
    switch (action.type) {
        case AccountActions.WEBAUTHN_AVAILABLE_ACTION.type:
            return action.payload.isAvailable;
        default:
            return state;
    }
};

const webAuthnActivated = (state : boolean = false, action : PledgerAction) => {
    switch (action.type) {
        case accountWServiceActions.GET_USER_PROFILE_SUCCEEDED_ACTION.type:
            return action.payload.data.webAuthnActivated;
        default:
            return state;
    }
};

const familyName = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case accountWServiceActions.GET_USER_PROFILE_SUCCEEDED_ACTION.type:
            return action.payload.data.identite.lastName;
        default:
            return state;
    }
};

const firstName = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case accountWServiceActions.GET_USER_PROFILE_SUCCEEDED_ACTION.type:
            return action.payload.data.identite.firstName;
        default:
            return state;
    }
};

const telephone = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case accountWServiceActions.GET_USER_PROFILE_SUCCEEDED_ACTION.type:
            return action.payload.data.phoneNumber;
        default:
            return state;
    }
};

const mail = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case accountWServiceActions.GET_USER_PROFILE_SUCCEEDED_ACTION.type:
            return action.payload.data.email;
        default:
            return state;
    }
};


export interface AccountPageComponentState extends PledgerPageComponentState {
    loaded: string
    familyName: string;
    firstName: string;
    telephone: string;
    mail: string;
    webAuthnAvailable:boolean;
    webAuthnActivated:boolean;
}

export const account : Reducer = (state={},action)=>{
    return{
        pageId:pageId(state.pageId,action),
        footerType: footerType(state.footerType, action),
        loaded: loaded(state.loaded, action),
        familyName: familyName(state.familyName, action),
        firstName: firstName(state.firstName, action),
        telephone: telephone(state.telephone, action),
        mail: mail(state.mail, action),
        webAuthnAvailable:webAuthnAvailable(state.webAuthnAvailable,action),
        webAuthnActivated:webAuthnActivated(state.webAuthnActivated,action)
    }
}
